import axios from 'axios'
import router from '@/router'
import store from '@/store'
import { baseconfig } from "@/config.js";

//import NProgress from 'nprogress'
// NProgress.inc(0.2)
// NProgress.configure({ easing: 'ease', speed: 500, showSpinner: false, parent: '.tab-content' })

// 环境的切换
// if (process.env.NODE_ENV == 'development') {
//     axios.defaults.baseURL = 'http://localhost:50001';
// } else if (process.env.NODE_ENV == 'debug') {
//     axios.defaults.baseURL = 'http://localhost:50001';
// } else if (process.env.NODE_ENV == 'production') {
//     axios.defaults.baseURL = 'http://localhost:50001';
// }

// axios.defaults.timeout = 10000;

/** 
 * 跳转登录页
 * 携带当前页面路由，以期在登录页面完成登录后返回当前页面
 */
const toLogin = () => {
    if (router.currentRoute.fullPath.indexOf('login') == -1) {
        router.replace({
            path: '/login',
            query: {
                backurl: router.currentRoute.fullPath
            }
        })
    }

}

/** 
 * 请求失败后的错误统一处理 
 *  请求失败的状态码
 */
// const errorHandle = (status, other) => {
//     // 状态码判断
//     switch (status) {
//         case 401:
//             toLogin();
//             break;
//         case 403:
//             store.dispatch('admin/removeAdminID')
//             store.dispatch('admin/removeToken')
//             toLogin();
//             break;
//         case 404:
//         case 500:
//             router.replace({
//                 path: '/login'
//             })
//             break;
//         default:
//             console.log(other);
//     }
// }

const CancelToken = axios.CancelToken
const source = CancelToken.source()

var instance = axios.create({ timeout: 1000 * 36 })
    // instance.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';

/** 
 * 请求拦截器 
 * 每次请求前，如果存在token则在请求头中携带token 
 */
instance.interceptors.request.use(function(config) {
    //NProgress.start()

    const token = store.getters.token
    const adminToken = store.getters.adminID
    if (token && token.length > 0) {
        config.headers.common['Authorization'] = token
    }
    if (adminToken && adminToken.length > 0) {
        config.headers.common['AdminToken'] = adminToken
    }
    config.headers.common['v'] = baseconfig.v
    config.headers.common['platform'] = 3
    
    return config;
}, function(error) {
    // 对请求错误做些什么
    return Promise.reject(error);
});

// 添加响应拦截器
instance.interceptors.response.use(function(response) {
    // 对响应数据做点什么
    // if (response.status === 200) {
    //     return Promise.resolve(response)
    // } else {
    //     return Promise.reject(response)
    // }
    //NProgress.done()
    if (!Object.keys(response.data).length) {
        // Message.error('验签失败～')
        return Promise.reject()
    }
    if(response.data.msg !=undefined){
        response.data.message =response.data.msg
    }
    switch (response.data.code) {
        // case 100:
        // case 101: 
        //     break;
        case 102:
            var errorMessages=response.data.result
                var that=this
             
                if(errorMessages[0].field == 'adminToken'){
                    router.push('login')
                }else{
                    response.data.message = errorMessages[0].message
                    // this.$message.error(response.data.message);
                    // that.addRoleErrors.roleName=response.data.message
                    // that.$refs.addRoleForm.validateField("roleName");
                    // that.addRoleErrors.roleName=''
                }                      
            break;
        // case 100002:
        //     // Message.error(baseconfig.no_permission_message);
        //     break;
        // case 100001:
        //     // Message.error(baseconfig.net_error_message);
        //     break;
        default:
            // Message.error(meassme || baseconfig.net_error_message);
            break;
    }
    return response;
}, function(error) {
    // 对响应错误做点什么
    //NProgress.done()
    console.log(error)
    switch (error.response.status) {
        case 401:
        case 403:
            {
                store.dispatch('admin/removeAdminID')
                store.dispatch('admin/removeToken')
                toLogin()
            }
            break;
        case 404:
        case 500:
            router.replace({
                path: '/login'
            })
            break;
        default:
            break;

    }
    return Promise.reject(error)
});


// instance.interceptors.request.use(
//     config => {
//         // 登录流程控制中，根据本地是否存在token判断用户的登录情况        
//         // 但是即使token存在，也有可能token是过期的，所以在每次的请求头中携带token        
//         // 后台根据携带的token判断用户的登录情况，并返回给我们对应的状态码        
//         // 而后我们可以在响应拦截器中，根据状态码进行一些统一的操作。        
//         const token = store.getters.token;
//         if (token && token.length > 0) {
//             config.headers.common['Authorization'] = token
//                 //config.headers.Authorization = token
//         }
//         return config;
//     },
//     error => Promise.error(error))

// 响应拦截器
// instance.interceptors.response.use(
//     // 请求成功
//     res => res.status === 200 ? Promise.resolve(res) : Promise.reject(res),
//     // 请求失败
//     error => {
//         const { response } = error;
//         if (response) {
//             // 请求已发出，但是不在2xx的范围 
//             errorHandle(response.status, response.data.message);
//             return Promise.reject(response);
//         } else {
//             // 处理断网的情况
//             // eg:请求超时或断网时，更新state的network状态
//             // network状态在app.vue中控制着一个全局的断网提示组件的显示隐藏
//             // 关于断网组件中的刷新重新获取数据，会在断网组件中说明
//             // if (!window.navigator.onLine) {
//             //     store.commit('changeNetwork', false);
//             // } else {
//             //     return Promise.reject(error);
//             // }
//             return Promise.reject(error);
//         }
//     })

export default instance





// export function httpRequest(url, method, data, header) {
//     return new Promise((resolve, reject) => {
//         axios({
//                 method: method,
//                 url: url,
//                 data: data,
//                 headers: header
//             })
//             .then((response) => {
//                 resolve(response);
//             })
//             .catch(err => {
//                 reject(err)
//             })
//     })
// }